import { STRING } from './constants';

export default function isString(value) {
    return typeof value === STRING;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/common/is-string.js
// module id = 617
// module chunks = 29